module.exports = __webpack_public_path__ + "img/d20190921_1.270181e6.jpg";